import React, { useState } from "react";
import "./references.css";
import ProjectModal from "./ProjectModal";

const projects = [
  {
    title: "Sentosa Central Beach Bazaar",
    image: "/references/sentosa/hoarding_1.jpg",
    images: [
      "/references/sentosa/hoarding_1.jpg",
      "/references/sentosa/hoarding_2.jpg",
      "/references/sentosa/hoarding_3.jpg",
      "/references/sentosa/hoarding_4.jpg",
      "/references/sentosa/hoarding_5.jpg",
      "/references/sentosa/hoarding_6.jpg",
      "/references/sentosa/hoarding_7.jpg",
      "/references/sentosa/hoarding_8.jpg",
    ],
    progress: 90,
    badge: "NEW",
    services: [
      "Hoarding Works",
      "Masonry Works",
      "Plumbing & Sanitary Works",
      "Hacking & Demolition",
      "Drain Cover Works",
    ],
  },
  {
    title: "Singapore Badminton Association",
    image:
      "/references/singapore-badminton-association/singapore-badminton-association_1.jpg",
    images: [
      "/references/singapore-badminton-association/singapore-badminton-association_1.jpg",
      "/references/singapore-badminton-association/singapore-badminton-association_2.jpg",
      "/references/singapore-badminton-association/singapore-badminton-association_3.jpg",
      "/references/singapore-badminton-association/singapore-badminton-association_4.jpg",
      "/references/singapore-badminton-association/singapore-badminton-association_5.jpg",
      "/references/singapore-badminton-association/singapore-badminton-association_6.jpg",
      "/references/singapore-badminton-association/singapore-badminton-association_7.jpg",
    ],
    progress: 100,
    badge: null,
    services: [
      "Electrical Works",
      "Lighting Installation",
      "Ceiling Works",
    ],
  },
  {
    title: "Ng Teng Fong General Hospital",
    image: "/references/national-university-hospital/nuh_1.jpg",
    images: [
      "/references/national-university-hospital/nuh_1.jpg",
      "/references/national-university-hospital/nuh_2.jpg",
      "/references/national-university-hospital/nuh_3.jpg",
      "/references/national-university-hospital/nuh_4.jpg",
      "/references/national-university-hospital/nuh_5.jpg",
    ],
    progress: 100,
    badge: null,
    services: [
      "Hospital Fit-Out",
      "Electrical Works",
      "Partition Works",
    ],
  },
  {
    title: "High Bay Lights Installation",
    image: "/references/scaffolding/scaffolding_1.jpg",
    images: [
      "/references/scaffolding/scaffolding_1.jpg",
      "/references/scaffolding/scaffolding_2.jpg",
      "/references/scaffolding/scaffolding_3.jpg",
    ],
    progress: 100,
    badge: null,
    services: [
      "High Bay Lighting",
      "Electrical Installation",
      "Scaffolding Works",
    ],
  },
  {
    title: "Gardening Works",
    image: "/references/gardening/gardening_1.jpg",
    images: [
      "/references/gardening/gardening_1.jpg",
      "/references/gardening/gardening_2.jpg",
      "/references/gardening/gardening_3.jpg",
      "/references/gardening/gardening_4.jpg",
      "/references/gardening/gardening_5.jpg",
      "/references/gardening/gardening_6.jpg",
    ],
    progress: 100,
    badge: null,
    services: [
      "Landscaping",
      "Tree Trimming",
      "Maintenance Works",
    ],
  },
  {
    title: "Mandai Resort",
    image: "/references/mandai-resort/mandai_1.jpg",
    images: [
      "/references/mandai-resort/mandai_1.jpg",
      "/references/mandai-resort/mandai_2.jpg",
      "/references/mandai-resort/mandai_3.jpg",
      "/references/mandai-resort/mandai_4.jpg",
      "/references/mandai-resort/mandai_5.jpg",
      "/references/mandai-resort/mandai_6.jpg",
      "/references/mandai-resort/mandai_7.jpg",
      "/references/mandai-resort/mandai_8.jpg",
      "/references/mandai-resort/mandai_9.jpg",
    ],
    progress: 100,
    badge: "FEATURED",
    services: [
      "Electrical Works",
      "Lighting Installation",
      "Infrastructure Works",
    ],
  },
];

export default function References() {
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <div className="references-page">

      <section className="references-hero">
        <h1>Project References</h1>
        <p>
          A selection of completed renovation, construction, and infrastructure
          projects delivered by Shamshine Pte Ltd.
        </p>
      </section>

      <section className="projects-grid">
        {projects.map((project) => (
          <div
            key={project.title}
            className="course-card"
            onClick={() => setSelectedProject(project)}
          >

            {project.badge && (
              <div className="badge">{project.badge}</div>
            )}

            <div className="course-image">
              <img
                src={project.image}
                alt={project.title}
                loading="lazy"
              />
            </div>

            <div className="course-body">
              <h3>{project.title}</h3>

              <div className="course-footer">
                <span>Completed Project</span>

                <div
                  className="progress-circle"
                  style={{ "--progress": project.progress }}
                >
                  <span>{project.progress}%</span>
                </div>
              </div>

              <button
                className="view-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedProject(project);
                }}
              >
                View Project
              </button>
            </div>

          </div>
        ))}
      </section>

      {selectedProject && (
        <ProjectModal
          project={selectedProject}
          onClose={() => setSelectedProject(null)}
        />
      )}

    </div>
  );
}
